document.addEventListener('DOMContentLoaded', function() {
  const videoCards = document.querySelectorAll('.video-card');
  
  videoCards.forEach(card => {
    const playButton = card.querySelector('.play-button');
    const soundToggle = card.querySelector('.sound-toggle');
    const fullscreenToggle = card.querySelector('.fullscreen-toggle');
    
    // Main card click handler
    card.addEventListener('click', function(e) {
      // Don't trigger if clicking on control buttons
      if (e.target.closest('.control-btn')) return;
      
      const videoUrl = this.dataset.videoUrl;
      
      if (videoUrl && videoUrl.includes('youtube')) {
        handleYouTubeVideo(this);
      } else if (videoUrl && videoUrl.includes('vimeo')) {
        handleVimeoVideo(this);
      } else if (videoUrl) {
        handleDirectVideo(this);
      }
    });
    
    // Sound toggle handler
    if (soundToggle) {
      soundToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleSound(card);
      });
    }
    
    // Fullscreen toggle handler
    if (fullscreenToggle) {
      fullscreenToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleFullscreen(card);
      });
    }
  });
  
  function handleYouTubeVideo(card) {
    const youtubeContainer = card.querySelector('.youtube-container');
    if (youtubeContainer && !youtubeContainer.querySelector('iframe')) {
      const videoId = youtubeContainer.dataset.videoId;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&rel=0&modestbranding=1`;
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      
      youtubeContainer.appendChild(iframe);
      card.classList.add('playing');
      hidePlayButton(card);
    }
  }
  
  function handleVimeoVideo(card) {
    const vimeoContainer = card.querySelector('.vimeo-container');
    if (vimeoContainer && !vimeoContainer.querySelector('iframe')) {
      const videoId = vimeoContainer.dataset.videoId;
      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&controls=1&muted=0`;
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      
      vimeoContainer.appendChild(iframe);
      card.classList.add('playing');
      hidePlayButton(card);
    }
  }
  
  function handleDirectVideo(card) {
    const video = card.querySelector('.video-element');
    const playButton = card.querySelector('.play-button');
    
    if (video) {
      if (video.paused) {
        // Start with unmuted for better user experience
        video.muted = false;
        video.play().catch(() => {
          // Fallback to muted if unmuted autoplay fails
          video.muted = true;
          video.play();
        });
        card.classList.add('playing');
        if (playButton) playButton.style.display = 'none';
      } else {
        video.pause();
        card.classList.remove('playing');
        if (playButton) playButton.style.display = 'flex';
      }
      updateSoundButton(card, video.muted);
    }
  }
  
  function toggleSound(card) {
    const video = card.querySelector('.video-element');
    if (video) {
      video.muted = !video.muted;
      updateSoundButton(card, video.muted);
    }
  }
  
  function updateSoundButton(card, isMuted) {
    const soundToggle = card.querySelector('.sound-toggle');
    const soundOn = soundToggle.querySelector('.sound-on');
    const soundOff = soundToggle.querySelector('.sound-off');
    
    if (isMuted) {
      soundOn.style.display = 'none';
      soundOff.style.display = 'block';
    } else {
      soundOn.style.display = 'block';
      soundOff.style.display = 'none';
    }
  }
  
  function toggleFullscreen(card) {
    // For iOS Safari, use native video fullscreen when possible
    const video = card.querySelector('.video-element');
    const iframe = card.querySelector('iframe');
    
    if (video && typeof video.webkitEnterFullscreen === 'function') {
      // Use native iOS video fullscreen
      if (video.webkitDisplayingFullscreen) {
        video.webkitExitFullscreen();
      } else {
        video.webkitEnterFullscreen();
      }
      return;
    }
    
    // For embedded videos or non-iOS, use custom fullscreen
    if (card.classList.contains('fullscreen')) {
      exitFullscreen(card);
    } else {
      enterFullscreen(card);
    }
  }
  
  function enterFullscreen(card) {
    // Check if we're on iOS Safari
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    
    if (isIOS && isSafari) {
      // For iOS Safari, use a simpler approach
      card.classList.add('fullscreen');
      document.body.classList.add('fullscreen-active');
      
      // Lock viewport
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        card.dataset.originalViewport = viewport.content;
        viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      }
    } else {
      // Desktop/Android approach - move to body
      card.dataset.originalParent = card.parentElement.className;
      
      // Create backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'fullscreen-backdrop';
      document.body.appendChild(backdrop);
      
      // Move card to body
      document.body.appendChild(card);
      card.classList.add('fullscreen');
    }
    
    document.body.style.overflow = 'hidden';
    
    // Update fullscreen button icon
    updateFullscreenButton(card, true);
    
    // Try native fullscreen as additional layer
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen().catch(() => {});
    }
  }
  
  function exitFullscreen(card) {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    
    if (isIOS && isSafari) {
      // iOS Safari approach
      card.classList.remove('fullscreen');
      document.body.classList.remove('fullscreen-active');
      
      // Restore viewport
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport && card.dataset.originalViewport) {
        viewport.content = card.dataset.originalViewport;
        delete card.dataset.originalViewport;
      }
    } else {
      // Desktop/Android approach
      const backdrop = document.querySelector('.fullscreen-backdrop');
      if (backdrop) backdrop.remove();
      
      card.classList.remove('fullscreen');
      
      // Return to original container
      const videosContainer = document.querySelector('.videos-container');
      if (videosContainer) {
        videosContainer.appendChild(card);
      }
    }
    
    document.body.style.overflow = '';
    updateFullscreenButton(card, false);
    
    // Exit native fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(() => {});
    }
  }
  
  function updateFullscreenButton(card, isFullscreen) {
    const fullscreenToggle = card.querySelector('.fullscreen-toggle');
    if (!fullscreenToggle) return;
    
    const expandIcon = fullscreenToggle.querySelector('.expand-icon');
    const compressIcon = fullscreenToggle.querySelector('.compress-icon');
    
    if (isFullscreen) {
      expandIcon.style.display = 'none';
      compressIcon.style.display = 'block';
    } else {
      expandIcon.style.display = 'block';
      compressIcon.style.display = 'none';
    }
  }
  
  function hidePlayButton(card) {
    const playButton = card.querySelector('.play-button');
    if (playButton) playButton.style.display = 'none';
  }
  
  // Handle direct video events
  const videos = document.querySelectorAll('.video-element');
  videos.forEach(video => {
    const card = video.closest('.video-card');
    
    video.addEventListener('loadedmetadata', function() {
      // Initialize sound button state
      updateSoundButton(card, this.muted);
    });
    
    video.addEventListener('ended', function() {
      const playButton = card.querySelector('.play-button');
      card.classList.remove('playing');
      if (playButton) playButton.style.display = 'flex';
    });
    
    video.addEventListener('pause', function() {
      const playButton = card.querySelector('.play-button');
      card.classList.remove('playing');
      if (playButton) playButton.style.display = 'flex';
    });
    
    video.addEventListener('play', function() {
      const playButton = card.querySelector('.play-button');
      card.classList.add('playing');
      if (playButton) playButton.style.display = 'none';
      updateSoundButton(card, this.muted);
    });
    
    // Handle iOS play button tap
    video.addEventListener('click', function(e) {
      e.stopPropagation();
      if (this.paused) {
        this.play();
      } else {
        this.pause();
      }
    });
  });
  
  // Handle fullscreen changes
  document.addEventListener('fullscreenchange', handleFullscreenChange);
  document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
  
  function handleFullscreenChange() {
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
    if (!fullscreenElement) {
      // Exited fullscreen
      const fullscreenCard = document.querySelector('.video-card.fullscreen');
      if (fullscreenCard) {
        exitFullscreen(fullscreenCard);
      }
    }
  }
  
  // Handle escape key to exit fullscreen
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const fullscreenCard = document.querySelector('.video-card.fullscreen');
      if (fullscreenCard) {
        exitFullscreen(fullscreenCard);
      }
    }
  });
});